// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filepicker {
  font-family: sans-serif;
}

div.filepicker {
  text-align: center;
  padding: 5px;
  background-color: #e1e1e1;
  border-radius: 5px;
  min-height: 60px;
  border: 2px dashed #c7c7c7;
}

/* Icon */
.filepicker-file-icon {
  position: relative;
  display: inline-block;
  margin: 1.5em 0 2.5em 0;
  padding-left: 45px;
  color: black;
}
.filepicker-file-icon::before {
  position: absolute;
  top: -7px;
  left: 0;
  width: 29px;
  height: 34px;
  content: '';
  border: solid 2px #7f7f7f;
  border-radius: 2px;
}
.filepicker-file-icon::after {
  font-size: 11px;
  line-height: 1.3;
  position: absolute;
  top: 9px;
  left: -4px;
  padding: 0 2px;
  content: 'file';
  content: attr(data-filetype);
  text-align: right;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #fff;
  background-color: #000;
}
.filepicker-file-icon .fileCorner {
  position: absolute;
  top: -7px;
  left: 22px;
  width: 0;
  height: 0;
  border-width: 11px 0 0 11px;
  border-style: solid;
  border-color: white transparent transparent #920035;
}

.filepicker.dropzone .dz-preview.dz-image-preview {
  background: none;
}

.filepicker.dropzone .dz-preview.dz-image-preview .dz-image {
  border-radius: 5px;
}

.dropzone.dz-clickable {
  cursor: pointer;
}

.dropzone-aside > div.bouncer {
  margin-top: 20px;
  margin-bottom: 20px;
  margin-right: auto;
  margin-left: auto;
}

.dataset > div > div.bouncer {
  height: 20px;
  width: 20px;
}
`, "",{"version":3,"sources":["webpack://./static/popups/upload/Upload.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb","sourcesContent":[".filepicker {\n  font-family: sans-serif;\n}\n\ndiv.filepicker {\n  text-align: center;\n  padding: 5px;\n  background-color: #e1e1e1;\n  border-radius: 5px;\n  min-height: 60px;\n  border: 2px dashed #c7c7c7;\n}\n\n/* Icon */\n.filepicker-file-icon {\n  position: relative;\n  display: inline-block;\n  margin: 1.5em 0 2.5em 0;\n  padding-left: 45px;\n  color: black;\n}\n.filepicker-file-icon::before {\n  position: absolute;\n  top: -7px;\n  left: 0;\n  width: 29px;\n  height: 34px;\n  content: '';\n  border: solid 2px #7f7f7f;\n  border-radius: 2px;\n}\n.filepicker-file-icon::after {\n  font-size: 11px;\n  line-height: 1.3;\n  position: absolute;\n  top: 9px;\n  left: -4px;\n  padding: 0 2px;\n  content: 'file';\n  content: attr(data-filetype);\n  text-align: right;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  color: #fff;\n  background-color: #000;\n}\n.filepicker-file-icon .fileCorner {\n  position: absolute;\n  top: -7px;\n  left: 22px;\n  width: 0;\n  height: 0;\n  border-width: 11px 0 0 11px;\n  border-style: solid;\n  border-color: white transparent transparent #920035;\n}\n\n.filepicker.dropzone .dz-preview.dz-image-preview {\n  background: none;\n}\n\n.filepicker.dropzone .dz-preview.dz-image-preview .dz-image {\n  border-radius: 5px;\n}\n\n.dropzone.dz-clickable {\n  cursor: pointer;\n}\n\n.dropzone-aside > div.bouncer {\n  margin-top: 20px;\n  margin-bottom: 20px;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n.dataset > div > div.bouncer {\n  height: 20px;\n  width: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
